module.exports = __webpack_public_path__ + "img/shop1-6.d683d99f.png";